import { appConfig } from '../config';
import { graphFetch } from './client';

let cachedSiteId: string | null = null;
let pending: Promise<string> | null = null;

/**
 * Resolve the Graph site ID for the configured SharePoint site once per
 * app session. All list operations key off this ID.
 */
export async function getSiteId(): Promise<string> {
  if (cachedSiteId) return cachedSiteId;
  if (!pending) {
    const { hostname, sitePath } = appConfig.sharePoint;
    pending = graphFetch<{ id: string }>(`/sites/${hostname}:${sitePath}`)
      .then((site) => {
        cachedSiteId = site.id;
        return site.id;
      })
      .finally(() => {
        pending = null;
      });
  }
  return pending;
}
